import { useEffect } from "react";
import { observer } from "mobx-react";
import { translationStore } from "@/i18n";
import { SYSTEM_ROLE_VOCABULARY } from "@/i18n/locales/system-role-vocabulary";
import { useFeatureFlag } from "@/hooks/use-feature-flag";
import { CUSTOM_SYSTEM_ROLES_FLAG } from "@/lib/launchdarkly/flags";

/**
 * Applies the System Role vocabulary overlay while `custom-system-roles` is on
 * (NG-1246, epic NG-1233).
 *
 * This is the single place the flag is read for the rename: the overlay lands on
 * the translation store, so the ~30 renamed labels reach their call sites through
 * the same `t(key)` they already use. Nothing else in the app knows a flag
 * decides the wording.
 *
 * It renders nothing and lives inside `<StoreProvider>` next to the other sync
 * components, because `useFeatureFlag` reads the store — `<TranslationProvider>`
 * wraps the store provider, so the bridge cannot live in the i18n layer itself.
 */
export const SystemRoleVocabularySync = observer(function SystemRoleVocabularySync() {
  const enabled = useFeatureFlag(CUSTOM_SYSTEM_ROLES_FLAG);

  useEffect(() => {
    translationStore.setVocabularyOverlay(enabled ? SYSTEM_ROLE_VOCABULARY : null);
  }, [enabled]);

  return null;
});
